import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormTextField from '../../form/FormTextField';
import FormSelect from '../../form/FormSelect';
import FormDateField from '../../form/FormDateField';
import model from '../assets/models/closeJobModel';

const CloseJobFields = ({ disabled }) => {
  return (
    <>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.closedFilled.id}
          label={model.closedFilled.name}
          disabled={disabled}
          options={model.closedFilled.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormDateField
          id={model.closedFilledDate.id}
          label={model.closedFilledDate.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.numberApplicants.id}
          label={model.numberApplicants.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.numberApplicantsInterviewed.id}
          label={model.numberApplicantsInterviewed.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.numberOffersMade.id}
          label={model.numberOffersMade.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
    </>
  );
};

CloseJobFields.defaultProps = {
  disabled: false,
};

CloseJobFields.propTypes = {
  disabled: PropTypes.bool,
};

export default CloseJobFields;
